export default {
  title: 'Mises à jour',
  fields: {
    app_version: "Version de l'app",
    description: 'Description',
    created_at: 'Créé le',
  },
};
